import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

import { Language } from '../types';

import { languagesKeys } from './query-keys';

export async function getLanguages(): Promise<Language[]> {
  return mediaManagerClient.get('/api/v1/languages').then(({ data }) => data);
}

type QueryFnType = typeof getLanguages;

interface UseLanguagesParams {
  config?: QueryConfig<QueryFnType>;
}

export function useLanguages({ config = {} }: UseLanguagesParams = {}) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: languagesKeys.all,
    queryFn() {
      return getLanguages();
    },
  });
}
